import axiosInstance from "auth/FetchInterceptor";
import {
  SETTING_ORDER_CANCEL_API,
  REFUND_ORDER_CANCEL_API,
  GET_ALL_CANCEL_ORDER_REFUND_API,
} from "constants/ApiConstant";
const OrderCancelService = {};

OrderCancelService.getOrderCancelConfig = function () {
  return axiosInstance.get(SETTING_ORDER_CANCEL_API, null);
};

OrderCancelService.updateOrderCancelConfig = function (data) {
  return axiosInstance.put(SETTING_ORDER_CANCEL_API, data);
};

OrderCancelService.getAllRefundList = function () {
  return axiosInstance.get(GET_ALL_CANCEL_ORDER_REFUND_API, null);
};

OrderCancelService.updateOrderCancelRefund = function (data) {
  return axiosInstance.put(REFUND_ORDER_CANCEL_API, data);
};

export default OrderCancelService;
